import {useMeinModal, withMeinModal} from '@components/@ui/Modal/useMeinModal';
import {Fade, Modal, ModalProps} from '@mui/material';
import classNames from 'classnames';
import {FC, PropsWithChildren} from 'react';
import styles from './MeinModal.module.css';

interface IProps
    extends Omit<ModalProps, 'open' | 'children'>, PropsWithChildren {
    open?: boolean;
    classNameModal?: string;
    classNameContent?: string;
    fullWidth?: boolean;
    fullscreen?: boolean;
    position?: 'top' | 'center';
    onClose?: (
        event: object,
        reason: 'backdropClick' | 'escapeKeyDown',
    ) => void;
}

const MeinModalBase: FC<IProps> = ({
    children,
    open,
    onClose,
    classNameModal,
    classNameContent,
    fullWidth,
    fullscreen,
    position = 'center',
    ...props
}) => {
    const context = useMeinModal();

    const isControlled = open !== undefined;

    const isOpen = isControlled ? open : context?.isOpen || false;

    const handleClose = (
        e: object,
        reason: 'backdropClick' | 'escapeKeyDown',
    ) => {
        if (isControlled && onClose) {
            onClose(e, reason);
        } else if (context) {
            context.closeModal();
        }
    };

    return (
        <Modal
            className={classNames(styles.modal, classNameModal, {
                [styles.center]: position === 'center',
            })}
            open={isOpen}
            onClose={handleClose}
            closeAfterTransition
            slotProps={{
                backdrop: {
                    timeout: 400,
                },
            }}
            {...props}
        >
            <Fade in={isOpen} timeout={400}>
                <div
                    className={classNames(
                        styles.contentWrapper,
                        classNameContent,
                        {[styles.fullWidth]: fullWidth},
                        {[styles.fullScreen]: fullscreen},
                    )}
                >
                    {children}
                </div>
            </Fade>
        </Modal>
    );
};

export const MeinModal = withMeinModal(MeinModalBase);
